import React, { useEffect, useState } from "react";
import { UrduInput } from "../../../Components/Shared/UrduInput";
import { UiModal } from "../../../Components/Shared/UiModal";

const EMPTY_FORM = {
  plotSize: "",
  plotSize_ur: "",
  layout: "",
  structure: "",
  interiorDesign: "",
  boQs: "",
  status: true,
};

const REQUIRED_FIELDS = [
  { name: "plotSize", label: "Plot Size", placeholder: "Enter Plot Size" },
  { name: "layout", label: "Layout", placeholder: "Enter Layout Price" },
  { name: "structure", label: "Structure", placeholder: "Enter Structure Price" },
  {
    name: "interiorDesign",
    label: "Interior Design",
    placeholder: "Enter Interior Price",
  },
  { name: "boQs", label: "BoQs", placeholder: "Enter BoQs Price" },
];

function PricingModal({
  isOpen,
  onClose,
  onSubmit,
  editData,
  titlePrefix = "",
}) {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!isOpen) {
      setFormData(EMPTY_FORM);
      setErrors({});
      return;
    }

    if (editData) {
      setFormData({
        plotSize: editData.plotSize || "",
        plotSize_ur: editData.plotSize_ur || "",
        layout: editData.layout || "",
        structure: editData.structure || "",
        interiorDesign: editData.interiorDesign || "",
        boQs: editData.boQs || "",
        status: editData.status !== undefined ? editData.status : true,
      });
    } else {
      setFormData(EMPTY_FORM);
    }
    setErrors({});
  }, [isOpen, editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const nextErrors = {};
    REQUIRED_FIELDS.forEach(({ name }) => {
      if (!String(formData[name] ?? "").trim()) {
        nextErrors[name] = "This field is required";
      }
    });
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const pricingData = {
      plotSize: formData.plotSize,
      plotSize_ur: formData.plotSize_ur,
      layout: formData.layout,
      structure: formData.structure,
      interiorDesign: formData.interiorDesign,
      boQs: formData.boQs,
      status: formData.status,
      ...(editData && editData.id ? { id: editData.id } : {}),
    };
    onSubmit(pricingData);
  };

  const isEditMode = Boolean(editData);
  const isPremium = Boolean(titlePrefix);
  const eyebrow = isPremium ? "Premium Pricing" : "Budget Pricing";
  const title = isEditMode
    ? isPremium
      ? "Edit Premium Pricing"
      : "Edit Pricing"
    : isPremium
      ? "Add Premium Pricing"
      : "Add Pricing";

  return (
    <UiModal
      isOpen={isOpen}
      onClose={onClose}
      eyebrow={eyebrow}
      title={title}
      as="form"
      onSubmit={handleSubmit}
      footer={
        <>
          <button
            type="button"
            className="ui-btn-cancel min-w-[108px]"
            onClick={onClose}
          >
            Cancel
          </button>
          <button type="submit" className="ui-btn-save min-w-[108px]">
            {isEditMode ? "Update" : "Save"}
          </button>
        </>
      }
    >
      <section className="ui-modal-section">
        <h4 className="ui-modal-section-title">Pricing details</h4>
        <div className="space-y-4">
          <div>
            <label className="ui-form-label">
              Plot Size <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="plotSize"
              value={formData.plotSize}
              onChange={handleChange}
              placeholder="Enter Plot Size"
              className={`ui-input-field ${
                errors.plotSize ? "border-brand-error" : ""
              }`}
            />
            {errors.plotSize ? (
              <p className="ui-form-error">{errors.plotSize}</p>
            ) : null}
            <UrduInput
              label="پلاٹ کا سائز"
              name="plotSize_ur"
              value={formData.plotSize_ur}
              onChange={handleChange}
            />
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {REQUIRED_FIELDS.filter((field) => field.name !== "plotSize").map(
              ({ name, label, placeholder }) => (
                <div key={name}>
                  <label className="ui-form-label">
                    {label} <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    placeholder={placeholder}
                    className={`ui-input-field ${
                      errors[name] ? "border-brand-error" : ""
                    }`}
                  />
                  {errors[name] ? (
                    <p className="ui-form-error">{errors[name]}</p>
                  ) : null}
                </div>
              ),
            )}
          </div>
        </div>
      </section>
    </UiModal>
  );
}

export default PricingModal;
